import React from 'react';
import './Modal1.css'


const Modal1 = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modalinicio">
      <div className="modal-content-m1">
        <span className="close" onClick={onClose}>&times;</span>
        {children}
      </div>
    </div>
  );
};

export default Modal1;
